import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IQuoteBehavior } from "../../../../documaker/domain/format/objects";

export interface IQuoteBehaviorPropertyEditable {
  quoteBehavior(): IPropertyEditable<IQuoteBehavior>;
}

export function instanceOfIQuoteBehaviorPropertyEditable(instance: any): instance is IQuoteBehaviorPropertyEditable {
  return instance
      && instance.quoteBehavior
      && instanceOfIPropertyEditable<IQuoteBehavior>(instance.quoteBehavior());
}
